import { StatisticalAnalysisSidebarBase, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { uniqueId } from 'lodash'
import { StatisticalAnalysisHeaderNavigationItems, StatisticalAnalysisHeaderValues, StatisticalAnalysisTypeNavigation } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDelayAndResponseEnum, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum, StatisticalAnalysisDossiers, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { StatisticalAnalysisTemporalFilterOptions } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
export interface StatisticalAnalysisDelaysAndResponseTimesDossierSearchInfo {
    typeDelaysAndResponseTimes: Nullable<StatisticalAnalysisSidebarItemCombo>
    typeSearch: Nullable<StatisticalAnalysisSidebarItemCombo>
    laboratories: Nullable<LaboratoryStatisticalAnalysisSidebarDateInput[]>
    startDate: Nullable<Date>
    endDate: Nullable<Date>
    onlyValidatedCases: Nullable<boolean>
}

export interface StatisticsAnalysisDelaysAndResponseTimesTrackingItems extends Partial<StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisDelayAndResponseEnum>> {
    label: string
    key: Nullable<StatisticalAnalysisDelayAndResponseEnum>
}

export interface StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo extends StatisticalAnalysisDelaysAndResponseTimesDossierSearchInfo {
    trackingItems: Nullable<StatisticalInfoPaginatorTrackingItems[]>
    trackingGeneralSelected: Nullable<StatisticalAnalysisHeaderNavigationItems<number>>
    trackingDetailSelected: Nullable<StatisticsAnalysisDelaysAndResponseTimesTrackingItems>
    typeDelay: Nullable<StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum>
    timeFilter: Nullable<StatisticalAnalysisTemporalFilterOptions>
    filterTimeSheetId: Nullable<StatisticalAnalysisTimesheetItems>
}

export const StatisticalDelaysAndResponseTimesOptionsComboSidebarTypeTimes = [
    StatisticalAnalysisEnumsAndKeys.TRO.getModel(),
    StatisticalAnalysisEnumsAndKeys.DELAY.getModel()
]

export const StatisticalDelaysAndResponseTimesOptionsComboSidebarTypeTimesPreselection = StatisticalDelaysAndResponseTimesOptionsComboSidebarTypeTimes[0]

export const statisticalDelaysAndResponseTimesDynamicLabelCheckbox =
    (selection: StatisticalAnalysisSidebarItemCombo): string => {
        switch (selection.id) {
        case StatiscalAnalysisTypeCases.CASE:
            return 'statisticalAnalysis.sidebar.onlyValidatedCases'
        case StatiscalAnalysisTypeCases.SAMPLE:
            return 'statisticalAnalysis.sidebar.onlyValidatedSamples'
        case StatiscalAnalysisTypeCases.PORTION:
            return 'statisticalAnalysis.sidebar.onlyValidatedPortions'
        case StatiscalAnalysisTypeCases.SUBPORTION:
            return 'statisticalAnalysis.sidebar.onlyValidatedSubportions'
        default:
            return ''
        }
    }

export interface StatisticalAnalysisDossierDelaysAndResponseTimeState extends StatisticalAnalysisSidebarBase {
    headerData: StatisticalAnalysisHeaderValues
    viewDetail: StatisticalAnalysisViewDetailParams
    externalInfo: StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo
    generalView: boolean
    promiseNavigationItems: Nullable<Promise<void>>
}
export const initialStatisticalAnalysisDossierDelaysAndResponseTimeModelState =
    (): StatisticalAnalysisDossierDelaysAndResponseTimeState => ({
        sidebar: {
            title: 'statisticalAnalysis.sections.delaysAndResponseTimes',
            id: 'delays-and-response-time',
            components: [
                {
                    name: 'StatisticalAnalysisSidebarSearchType',
                    id: uniqueId(),
                    props: {
                        required: true,
                        options: StatisticalDelaysAndResponseTimesOptionsComboSidebarTypeTimes,
                        label: 'statisticalAnalysis.sidebar.timesAndDelays',
                        multiple: false,
                        modelKey: 'typeDelaysAndResponseTimes',
                        preselection: StatisticalDelaysAndResponseTimesOptionsComboSidebarTypeTimesPreselection
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarSearchBy',
                    id: uniqueId(),
                    props: {
                        options: [
                            StatisticalAnalysisEnumsAndKeys.CASE.getModel(),
                            StatisticalAnalysisEnumsAndKeys.SAMPLE.getModel(),
                            StatisticalAnalysisEnumsAndKeys.PORTION.getModel(),
                            StatisticalAnalysisEnumsAndKeys.SUBPORTION.getModel()
                        ],
                        preselection: StatisticalAnalysisEnumsAndKeys.CASE.getModel()
                    }
                },
                {
                    name: 'StatisticalAnalysisSidebarDateAndCenters',
                    id: uniqueId(),
                    props: { }
                },
                {
                    name: 'StatisticalAnalysisSidebarCheckbox',
                    id: uniqueId(),
                    props: {
                        label: 'statisticalAnalysis.sidebar.onlyValidatedCases',
                        nameCheckbox: 'onlyValidatedCases',
                        dynamicLabel: {
                            active: true,
                            fnToExecute: statisticalDelaysAndResponseTimesDynamicLabelCheckbox
                        }
                    }
                }
            ]
        },
        externalInfo: {
            typeDelaysAndResponseTimes: null,
            typeSearch: null,
            laboratories: null,
            startDate: null,
            endDate: null,
            trackingItems: null,
            trackingGeneralSelected: null,
            trackingDetailSelected: null,
            typeDelay: null,
            filterTimeSheetId: null,
            onlyValidatedCases: null,
            timeFilter: null
        },
        headerData: {
            header: {
                total: 0,
                showTotal: false,
                startDate: new Date(),
                endDate: new Date(),
                elementType: ''
            },
            navigationItems: [],
            navigationType: StatisticalAnalysisTypeNavigation.NAVIGATION,
            styles: {
                background: require('@/img/delays-and-time-response-bg.jpg'),
                icon: ''
            }
        },
        viewDetail: {
            dossier: StatisticalAnalysisDossiers.DELAYS_AND_RESPONSE_TIMES,
            table: {
                contextMenuItems: {
                    detailChart: false,
                    detailList: true
                }
            },
            chart: {
                axis: {
                    xAxis: {
                        show: false
                    },
                    yAxis: {
                        show: false
                    }
                },
                showExtendedFilters: true
            }
        },
        generalView: true,
        promiseNavigationItems: null
    })
